import './scss/main.scss';

import initSliders from './sliders';

initSliders();

const toggleMenu = () => {
  const menu = document.querySelector('.page-header');
  menu.classList.toggle('is-open');
}
const toggle = document.querySelectorAll('.page-header__toggle');
toggle.forEach((el) => el.addEventListener('click', toggleMenu))


const useGoogleMaps = () => {
  let mapSettings = {}
  let map;

  const registerMap = (_mapSettings) => {
    const script = document.createElement('script')
    script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBU9IeHs3EFdjkbmZKvTv_Naamyoyg_csg&callback=initMap')
    script.setAttribute('async', true)
    script.setAttribute('defer', true)
    document.body.appendChild(script)
    mapSettings = _mapSettings;
  }

  const initMap = () => {
    const mapOptions = {
      zoom: 14,
      center: { lat: mapSettings.lat, lng: mapSettings.lng },
    };
    map = new google.maps.Map(document.getElementById("map"), mapOptions);
    const marker = new google.maps.Marker({
      position: { lat: mapSettings.lat, lng: mapSettings.lng },
      map: map,
    });
  }

  return { registerMap, initMap }
}

const candidatesTabs = () => {
  const onTabClick = (tab) => {
    const tabNumber = tab.target.getAttribute('data-tab')
    document.querySelectorAll('.tab-content').forEach((item) => item.classList.remove('active'))
    document.querySelectorAll('.candidates-tabs .tab-item').forEach((item) => item.classList.remove('active'))

    document.querySelector('')
  }

  const tabs = document.querySelectorAll('.candidates-tabs button');
  tabs.forEach((tab) => tab.addEventListener('click', onTabClick))
}


const { registerMap, initMap } = useGoogleMaps();
window.registerMap = registerMap;
window.initMap = initMap;
window.candidatesTabs = candidatesTabs;

const pageScriptsReady = new Event('pageScriptsReady')
window.dispatchEvent(pageScriptsReady);
